// extracted by mini-css-extract-plugin
export default {"panel":"w7mv9o8h","wide":"MdfwwwOI","title":"Gh6YyJ9d","hintIcon":"XefadRmo","subtitle":"myOy8OxL","footer":"qCtHZmS7"};